// The game title page template (docs/build/zone-games.md, the brief): the sections every /g/:id page renders, in
// order, and what each one needs to show. This is what `zones/games/zone.json` will carry once the zone framework
// takes per-game templates (request to w12-zones in zone-games.md); until then the order lives here, and the page
// (pages/game.ts) draws through it. Every section is hidden when it has nothing to show.

// "players" (wave 13, w13-loop): the Media and Notes tabs, players' shared shots and clips, and what changed because of
// their notes (src/notes.ts). It took over the clips section, whose clips now show in the Media tab.
// "bangers" (BANGERS.md slice 1): the developer's posts as the game's studio, then everyone's posts that embed it
// (people.ts gameBangers); hidden when both are empty.
export const MAIN_SECTIONS = ["media", "about", "whats-new", "bangers", "players", "reviews"] as const;
export const SIDE_SECTIONS = ["creator", "community", "claim"] as const;
export const AFTER_SECTIONS = ["more-like-this"] as const;

export type TitleSection = (typeof MAIN_SECTIONS)[number] | (typeof SIDE_SECTIONS)[number] | (typeof AFTER_SECTIONS)[number];

/** The shell's page colour and its ruby, which a game's own colour falls back to. */
export const PAGE_BG = "#121216";
export const SHELL_ACCENT = "#ff5a7a";
